import { SampleBoard } from "../../sample-boards/models/sample-board.model";
import {StrainRegistryEntry} from "@app/strain/registry/models/strain-registry-entry.model";

export class RegistryItemSampleBoard {
    public sampleBoard: SampleBoard;
    public registerItem: StrainRegistryEntry
    public requiredQuantity: number;
    public spareQuantity: number;

    constructor(item: any = {}) {
        this.sampleBoard = item?.sampleBoard ? new SampleBoard(item.sampleBoard) : null;
        this.registerItem = item?.registerItem ? new StrainRegistryEntry(item.registerItem) : null;
        this.requiredQuantity = item.requiredQuantity;
        this.spareQuantity = item.spareQuantity;
    }
}
